import Header from '@/components/index/Header';
import Footer from '@/components/index/Footer';
import styles from './index.module.scss';
export default () => {
  return (
    <div className={styles['deal-container']}>
      <Header />
      <div className={styles['deal-content']}>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>关于本政策</div>
          <p>
            丹纳赫中国生命科学平台重视您的隐私和个人信息的保护。本政策（“政策”）解释了丹纳赫中国生命科学平台及其关联公司、运营公司或相关公司如何收集、使用、共享、转移和处理从您或关于您收集的数据，这些公司的完整列表可在此处查询（统称为“丹纳赫中国生命科学平台”或“我们”）。
          </p>
          <p>
            “个人信息”是任何可以直接或间接识别个人或可以合理预期与个人相关联的信息。这可能包括姓名、地址、电话号码、信用卡详细信息、电子邮件地址、身份证号码、个人使用的电子设备的互联网协议（“IP”）地址或其他识别代码（即使缺乏其他识别信息）。匿名化处理后的信息和不可识别到个人的信息不被视为个人信息。
          </p>
          <p>
            与您联系的丹纳赫中国生命科学平台运营公司、关联公司或相关公司，在适用的情况下是负责处理您个人信息的数据控制方（或适用法律下的同等职责）。您可以在本政策附录1中找到作为数据控制方的相关法律实体列表。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>范围</div>
          <p>
            本政策描述了我们可能收集、处理或披露的有关您的个人信息类型，以及您如何通过行使适用的法律权利来进行管理。本政策适用于在线和离线信息收集，包括您使用我们运营的网站或子域名、任何移动应用程序，我们向您提供产品和/或服务或通知有关您潜在感兴趣项目时，以及您以面对面、电话或邮寄方式与我们联系的其他情况。
          </p>
          <p>
            可能有时您会收到与本政策分开的特定情况隐私申明，例如招聘等特定活动的隐私声明。。当您收到不同通知时，这些通知同样适用于我们与您的联系。如果您提供关于您自己以外的当事方的个人信息，您有责任确保他们知晓我们将如何处理其个人信息，并在适用的情况下，提前获得必要的同意。
          </p>
          <p>
            我们致力于根据适用法律处理个人信息。请注意，如果您不希望向我们提供您的个人信息，某些产品和/或服务可能无法向您提供。在适用法律允许的范围内，您使用任一或所有这些平台均表明您已被告知我们将按照本政策所述收集、使用、转移和披露您的信息。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 您的信息</div>
          <p>
            我们因许多不同原因与个人建立联系。这些联系可能导致我们直接或间接获取有关您的个人信息。下表总结了我们如何收集、处理和使用个人信息，我们处理个人信息的法律依据，以及个人信息的潜在接收者。请注意，并非所有举例均适用于所有情况。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>收集的个人信息的一般类别</div>
          <p>
            下表列明了在本政策范围内可能处理的个人信息的类别和来源，以及此类处理的目的和法律依据。请注意，丹纳赫中国生命科学平台、帮助我们提供产品或服务或帮助我们改善我们的营销或管理的合作伙伴、医疗卫生专业人士（“HCP”）、患者、有权访问个人信息的人士和潜在业务交易中涉及的各方可能共享、接收或处理表中包含的项目。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 身份和联系信息</div>
          <p>
            处理的个人信息示例
            姓名、电子邮件地址、邮政地址、电话号码、职称、专业许可证号码、帐户用户名和密码、IP地址、国家提供者标识符或州许可证号码
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>个人信息来源</div>
          <p>
            直接来自您；来自您的设备；来自我们的业务合作伙伴；来自公开可用的来源；来自您的HCP；来自您的患者；来自[公司]的其他运营公司、关联公司或相关公司，具体详情请参阅此处。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>处理个人信息的目的</div>
          <p>
            向您提供我们的产品和服务；与您沟通；识别和认证您；为您定制内容；检测安全事件；防范恶意或非法活动；确保我们的产品和服务得到适当使用；改善我们的产品和服务；短期临时使用；行政目的；营销、内部研究和开发；和/或质量保证
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的法律依据</div>
          <p>
            为了我们的合法利益；公共利益；遵守法律义务；履行合同；保护重要利益；协助医疗治疗和/或诊断；促进医疗产品/服务/设备的质量和安全；在我们要求并获得同意的情况下；以及可能依据法律根据个人信息的类型所要求或允许的其他目的
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 人口统计信息</div>
          <p>个人信息示例 年龄、性别、婚姻状况、残疾和出生日期</p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 个人信息来源</div>
          <p>
            直接来自您；来自您的设备；来自我们的业务合作伙伴；来自公开可用的来源；来自您的医疗卫生专业人士；来自您的患者；来自[公司]的其他运营公司、关联公司或相关公司，具体详情请参阅此处
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的目的</div>
          <p>
            向您提供我们的产品和服务；与您沟通；识别和认证您；为您定制内容；检测安全事件；防范恶意或非法活动；确保我们的产品和服务得到适当使用；改善我们的产品和服务；短期临时使用；行政目的；营销、内部研究和开发；和/或质量保证
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的法律依据</div>
          <p>
            为了我们的合法利益；公共利益；遵守法律义务；履行合同；保护重要利益；协助医疗治疗和/或诊断；确保医疗产品/服务/设备的质量和安全；在我们要求并获得同意的情况下；以及可能依据法律根据个人信息的类型所要求或允许的其他目的
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 商业和财务</div>
          <p>
            个人信息示例
            交易记录、产品和服务（已购买、获得或考虑）、请求的文件、客户服务记录、金融交易历史、价值转移和金融账户号码
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 个人信息来源</div>
          <p>
            直接来自您；来自您的设备；来自我们的业务合作伙伴；来自公开可用的来源；来自您的医疗卫生专业人士；来自您的患者；来自[公司]的其他运营公司、关联公司或相关公司，具体详情请参阅此处
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的目的</div>
          <p>
            向您提供我们的产品和服务；与您联系；识别和认证您；为您定制内容；检测安全事件；防范恶意或非法活动；确保我们的产品和服务得到适当使用；改善我们的产品和服务；短期临时使用；行政目的；营销、内部研究和开发；和/或质量保证。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的法律依据</div>
          <p>
            为了我们的合法利益；公共利益；遵守法律义务；履行合同；在要求并获得同意的情况下；以及可能依据法律根据个人信息的类型所要求或允许的其他目的。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 专业和教育信息</div>
          <p>
            个人信息示例
            职务或职位、雇主、国家提供者标识符号、工作技能、工作经历、研究生学位、认证、专业培训、对调查和问卷的回复以及我们的教育和培训活动的注册历史、LinkedIn资料
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 个人信息来源</div>
          <p>
            直接来自您；来自您的设备；来自我们的业务合作伙伴；来自公开可用的来源；来自您的医疗卫生专业人士；来自您的患者；来自[公司]的其他运营公司、关联公司或相关公司，具体详情请参阅此处。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的目的</div>
          <p>
            向您提供我们的产品和服务；与您联系；识别和认证您；为您定制内容；检测安全事件；防范恶意或非法活动；确保我们的产品和服务得到适当使用；改善我们的产品和服务；短期临时使用；行政目的；营销、内部研究和开发；和/或质量保证。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人数据个人信息的法律依据</div>
          <p>
            为了我们的合法利益；公共利益；遵守法律义务；履行合同；确保医疗产品/服务/设备的质量和安全；在我们要求并获得同意的情况下；以及可能依据法律根据个人数据个人信息的类型所要求或允许的其他目的
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 技术信息</div>
          <p>
            个人信息示例
            IP地址、浏览器类型、浏览器语言、设备类型、与您的设备关联的广告ID（例如Apple的广告标识符（IDFA）或Android的广告ID（AAID））、您使用我们的产品和服务的日期和时间、统一资源定位器或URL（即网站地址）在到达和离开我们的产品和服务之前访问的页面、在我们的产品和服务上的活动以及推荐网站或应用程序、从Cookies或其他类似技术收集的数据、地理位置信息
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 个人信息来源</div>
          <p>
            直接来自您；来自您的设备；来自我们的业务合作伙伴；来自公开可用的来源；来自您的医疗卫生专业人士；来自您的患者；来自[公司]的其他运营公司、关联公司或相关公司，具体详情请参阅此处
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的目的</div>
          <p>
            向您提供我们的产品和服务；与您联系；识别和认证您；为您定制内容；检测安全事件；防范恶意或非法活动；确保我们的产品和服务得到适当使用；改善我们的产品和服务；短期临时使用；行政目的；营销、内部研究和开发；和/或质量保证。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 个人信息的法律依据</div>
          <p>
            为了我们的合法利益；公共利益；遵守法律义务；履行合同；保护重要利益；协助医疗治疗和/或诊断；确保医疗产品/服务/设备的质量和安全；在我们要求并获得同意的情况下；以及可能依据法律根据个人信息的类型所要求或允许的其他目的
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 健康信息</div>
          <p>
            个人信息示例
            有关您治疗的信息，包括您的出生日期、性别、治疗日期、病史和治疗信息、患者报告的结果度量（例如，对问卷和调查的回复）、X光片、磁共振成像、医学扫描、用户活动、治疗活动的图片和视频、治疗完成和使用详细信息、与您的医疗卫生专业人士和/或患者的沟通，包括远程医疗会话中的音频和/或视频、过敏信息；医疗保险信息及相关详细信息
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 个人信息来源</div>
          <p>
            直接来自您；来自您的设备；来自我们的业务合作伙伴；来自公开可用的来源；来自您的医疗卫生专业人士；来自您的患者；来自[公司]的其他运营公司、关联公司或相关公司，具体详情请参阅此处
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的目的</div>
          <p>
            向您提供我们的产品和服务；与您联系；识别和认证您；为您定制内容；检测安全事件；防范恶意或非法活动；确保我们的产品和服务得到适当使用；改善我们的产品和服务；短期临时使用；行政目的；营销、内部研究和开发；和/或质量保证。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 处理个人信息的法律依据</div>
          <p>
            为了我们的合法利益；公共利益；遵守法律义务；履行合同；保护重要利益；协助医疗治疗和/或诊断；确保医疗产品/服务/设备的质量和安全；在我们要求并获得同意的情况下；以及可能依据法律根据个人信息的类型所要求或允许的其他目的。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>聚合、匿名和去标识化数据</div>
          <p>
            丹纳赫中国生命科学平台可能处理匿名化/去标识化数据。这是已去除可以直接或间接识别您的特征的数据，帮助您不再可识别，这些信息不再被视为数据保护法下的个人信息。我们依赖我们的合法商业利益、科学或历史研究和/或统计目的，您的同意或法律可能要求或允许的其他目的作为匿名化个人信息的法律依据。
          </p>
          <p>
            我们还可以获得和使用某些类型的组合数据集，如人口统计数据，用于任何目的（“整合数据”）。整合数据可能来源于您的个人信息，但不会直接或间接暴露您的身份。例如，我们可能会整合您的某些IT相关数据与他人的数据，以计算访问我们网站上某个特定功能的用户百分比。我们可以无限制地将整合数据用于各种目的。然而，如果我们重新组合或重新连接整合数据与您的个人信息，使其可以直接或间接识别您，我们将把组合数据视为将按照本政策使用的个人信息。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>聚合、匿名和去标识化数据</div>
          <p>
            我们还可以获得和使用某些类型的组合数据集，如人口统计数据，用于任何目的（“整合数据”）。整合数据可能来源于您的个人信息，但不会直接或间接暴露您的身份。例如，我们可能会整合您的某些IT相关数据与他人的数据，以计算访问我们网站上某个特定功能的用户百分比。我们可以无限制地将整合数据用于各种目的。然而，如果我们重新组合或重新连接整合数据与您的个人信息，使其可以直接或间接识别您，我们将把组合数据视为将按照本政策使用的个人信息。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>信息整合</div>
          <p>
            我们将在网站上收集的信息与您亲自向我们提供的信息、通过电子邮件或其他通信形式收到的信息结合起来。我们还将您提供的信息与我们从第三方、服务提供商、公开可用来源以及我们的运营公司、关联公司或相关公司获得的信息结合起来。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 来源于儿童的信息</div>
          <p>
            我们的网站和应用程序是为成人设计的。未经父母或法定监护人许可，我们不会有意收集14周岁及以下儿童的个人信息。如果您是父母或法定监护人，并认为您的孩子向我们提供了信息，您可以使用下方“联系我们”部分的详细信息通过电子邮件或书面形式联系我们。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>信息存储</div>
          <p>
            在符合适用法律法规要求的前提下，我们可能会将您的信息转移、处理和存储到美国、加拿大、印度、欧盟成员国、英国或其他国家。我们的关联公司或其他第三方服务提供商也可能将您的信息转移、处理或存储在美国或其他国家。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>跨境数据转移</div>
          <p>
            我们可能会将您的个人信息转移给您的个人信息最初收集之国家以外的国家的接收方。当我们以这种方式转移您的个人信息时，我们采取措施保护您的数据，以便与您国家的法律和要求一致，包括适用于跨境数据转移的要求。我们实施适当的技术和组织措施，以提供适当的安全级别，以防止您的个人信息意外或非法被毁坏、丢失、篡改、未经授权的披露或访问。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>数据的出售或转让</div>
          <p>
            如果我们参与出售或转让全部或部分业务资产或业务运营，通过股份或资产交易，您的个人信息可能会转让给收购组织，收购组织将被要求提供与处理您个人信息时至少相同或更高的保护标准。如果发生此类出售或转让，如果法律要求，您将被告知此事，可以撤销同意或（如适用）行使任何其他法律规定的权利。本政策
            "权利和选择 "部分详细说明了以下方面，受让方对您个人数据的处理和使用。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>Cookies、网络信标和其他跟踪工具</div>
          <p>
            正如上表所述，您与我们网站的互动是收集您信息的另一个来源。我们可能会使用“cookies”、网络信标和其他技术来帮助我们评估和改进我们所提供产品或服务的内容或功能。我们通过以下几种方法收集您的信息：
            网络信标 像素 标签 跟踪Cookies 营销Cookies 分析Cookies 社交媒体Cookies
            我们的Cookie政策提供了有关此主题的更详细信息，以及我们如何使用cookie来增强您的体验并更好地为您服务。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>第三方链接和工具</div>
          <p>
            我们可能会在我们的平台上链接到第三方网站或应用程序。本政策不适用于第三方网站或平台的隐私实践。请您仔细阅读该等第三方的隐私政策。我们不对这些第三方负责。我们的网站也可能提供包含其自己的cookies或跟踪技术的第三方内容。我们不控制这些技术的使用。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>数据存储</div>
          <p>
            我们将存储您的个人信息，直到为收集个人信息的目的实现或适用法律规定的期限，以较长者为准。在考虑存储您的个人信息期限时，我们将考虑以下因素：
            如果数据遭到未经授权的使用或披露，可能造成的伤害风险； 个人信息的数量和敏感性； 适用的法律要求；以及
            如果情况已发生变化，使得收集个人信息的目的可以通过其他方式实现。
            当不再需要保留您的个人信息时，我们将根据上述详细信息删除或匿名化数据。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>您的权利和选择</div>
          <p>
            一些司法管辖区为个人在处理其个人信息时提供相应权利。根据适用法律或法律依据，您可能有权：
            反对处理您的个人信息； 请求访问您的个人信息；
            如果您的个人信息不准确、不完整或已过时，您可请求更正个人信息，； 请求擦除/删除您的个人信息；
            撤回您对我们日后处理您的个人信息的同意个人信息； 请求限制处理您的个人信息，包括限制出售或共享您的个人信息；
            请求将您的个人信息转移给第三方； 选择撤回某些对第三方的转移。
            要行使您认为可能有权根据适用法律获得的权利，您可以直接通过提交此网页表格与我们联系。我们可能需要在履行您的请求之前验证您的身份，否则根据适用法律，我们可能无法采取行动处理您的申请。我们将及时通知您必要的要求。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>政策更新</div>
          <p>我们会持续更改此政策。最新的副本可在我们的网站上找到。请定期查看我们的网站以获取。</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};
